module.exports = __webpack_public_path__ + "static/media/Mail.9a7e9546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/iLocal-Delivery-Icons/Mail.svg
// module id = 13534
// module chunks = 0